import { render } from "./RouterView.vue?vue&type=template&id=645604c5"
import script from "./RouterView.vue?vue&type=script&lang=js"
export * from "./RouterView.vue?vue&type=script&lang=js"

import exportComponent from "/builds/enforb/elena-front-deploy/elena-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__